(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pawlycozy-youtube-shorts"] && !Shopify.designMode) return;
  try {
    
  class PawlycozyYoutube extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;
      this.dataset.ready = 'true';
      this.grid = this.querySelector('[data-video-grid]');
      this.dialog = this.querySelector('[data-video-dialog]');
      this.frame = this.querySelector('[data-video-frame]');
      this.dialogTitle = this.querySelector('[data-dialog-title]');
      this.dialogProduct = this.querySelector('[data-dialog-product]');
      this.lastTrigger = null;
      this.addEventListener('click', this.handleClick.bind(this));
      this.addEventListener('submit', this.handleSubmit.bind(this));
      this.dialog?.addEventListener('close', this.closeVideo.bind(this));
      this.dialog?.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.dialog.close();
      });
      this.schedulePosters();
      this.scheduleFeed();
    }

    schedulePosters() {
      const posters = Array.from(this.querySelectorAll('[data-youtube-poster]'));
      if (!posters.length) return;
      const loadPoster = (image) => {
        const fallback = image.currentSrc || image.src;
        image.addEventListener('error', () => {
          image.src = fallback;
          image.removeAttribute('data-youtube-poster');
        }, { once: true });
        image.src = `https://i.ytimg.com/vi/${encodeURIComponent(image.dataset.videoId)}/hq720.jpg`;
        image.removeAttribute('data-youtube-poster');
      };
      if (!('IntersectionObserver' in window)) {
        posters.forEach(loadPoster);
        return;
      }
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          observer.unobserve(entry.target);
          loadPoster(entry.target);
        });
      }, { rootMargin: '400px 0px' });
      posters.forEach((image) => observer.observe(image));
    }

    scheduleFeed() {
      if (!this.dataset.feedEndpoint || !this.grid) return;
      if (!('IntersectionObserver' in window)) {
        this.loadFeed();
        return;
      }
      const observer = new IntersectionObserver((entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        observer.disconnect();
        this.loadFeed();
      }, { rootMargin: '320px 0px' });
      observer.observe(this);
    }

    async loadFeed() {
      const endpoint = this.dataset.feedEndpoint;
      const status = this.querySelector('[data-feed-status]');
      const cacheKey = `pawlycozy-youtube:${endpoint}`;
      const cacheMs = Number(this.dataset.cacheMs) || 21600000;
      try {
        const cached = JSON.parse(localStorage.getItem(cacheKey) || 'null');
        if (cached?.savedAt && Date.now() - cached.savedAt < cacheMs) {
          this.renderFeed(cached.data);
          return;
        }
      } catch (error) {
        localStorage.removeItem(cacheKey);
      }
      try {
        const response = await fetch(endpoint, { credentials: 'omit', headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error(String(response.status));
        const data = await response.json();
        this.renderFeed(data);
        try {
          localStorage.setItem(cacheKey, JSON.stringify({ savedAt: Date.now(), data }));
        } catch (error) {
          status.textContent = '';
        }
      } catch (error) {
        status.textContent = '';
      }
    }

    renderFeed(data) {
      if (!Array.isArray(data?.videos) || data.videos.length === 0) return;
      const fragment = document.createDocumentFragment();
      data.videos.slice(0, 5).forEach((video, index) => {
        if (!video?.id) return;
        fragment.append(this.createVideoCard(video, index));
      });
      if (!fragment.childNodes.length) return;
      this.grid.replaceChildren(fragment);
      const count = this.querySelector('[data-subscriber-count]');
      if (count && data.subscriberCount) count.textContent = data.subscriberCount;
    }

    createVideoCard(video, index) {
      const article = document.createElement('article');
      article.className = 'pawlycozy-youtube__video-card';
      article.dataset.videoCard = '';
      article.dataset.videoId = video.id;
      article.dataset.slotIndex = String(index);
      const button = document.createElement('button');
      button.className = 'pawlycozy-youtube__poster';
      button.type = 'button';
      button.dataset.openVideo = '';
      button.dataset.videoId = video.id;
      button.dataset.videoTitle = video.title || '';
      button.dataset.slotIndex = String(index);
      button.setAttribute('aria-label', `${this.dataset.copyPlay} ${video.title || ''}`.trim());
      const image = document.createElement('img');
      image.className = 'pawlycozy-youtube__poster-image';
      image.src = video.thumbnail || `https://i.ytimg.com/vi/${encodeURIComponent(video.id)}/hq720.jpg`;
      image.alt = video.title || '';
      image.width = 720;
      image.height = 1280;
      image.loading = 'lazy';
      image.decoding = 'async';
      const shade = document.createElement('span');
      shade.className = 'pawlycozy-youtube__poster-shade';
      shade.setAttribute('aria-hidden', 'true');
      const play = document.createElement('span');
      play.className = 'pawlycozy-youtube__poster-play';
      play.setAttribute('aria-hidden', 'true');
      play.innerHTML = '<svg viewBox="0 0 24 24"><path d="M9 7.5v9l7-4.5-7-4.5Z"/></svg>';
      const badge = document.createElement('span');
      badge.className = 'pawlycozy-youtube__shorts-badge';
      badge.textContent = this.dataset.copyShorts;
      if (video.views) {
        const views = document.createElement('span');
        views.className = 'pawlycozy-youtube__view-count';
        views.textContent = `${video.views} ${this.dataset.copyViews}`;
        button.append(views);
      }
      const title = document.createElement('span');
      title.className = 'pawlycozy-youtube__video-title';
      title.textContent = video.title || '';
      button.append(image, shade, play, badge, title);
      article.append(button);
      const productTemplate = this.findTemplate('card-product', video.id, index);
      if (productTemplate) article.append(productTemplate.content.cloneNode(true));
      return article;
    }

    findTemplate(type, videoId, slotIndex) {
      const templates = Array.from(this.querySelectorAll(`template[data-${type}-template]`));
      return templates.find((template) => template.dataset.videoId && template.dataset.videoId === videoId)
        || templates.find((template) => template.dataset.slotIndex === String(slotIndex));
    }

    handleClick(event) {
      const closeButton = event.target.closest('[data-close-dialog]');
      if (closeButton) {
        this.dialog?.close();
        return;
      }
      const trigger = event.target.closest('[data-open-video]');
      if (!trigger) return;
      this.openVideo(trigger);
    }

    openVideo(trigger) {
      const videoId = trigger.dataset.videoId;
      if (!videoId || !this.dialog || !this.frame) return;
      this.lastTrigger = trigger;
      this.dialogTitle.textContent = trigger.dataset.videoTitle || '';
      this.frame.src = `https://www.youtube-nocookie.com/embed/${encodeURIComponent(videoId)}?autoplay=1&playsinline=1&rel=0`;
      this.dialogProduct.replaceChildren();
      const productTemplate = this.findTemplate('modal-product', videoId, trigger.dataset.slotIndex);
      if (productTemplate) this.dialogProduct.append(productTemplate.content.cloneNode(true));
      this.dialog.showModal();
    }

    closeVideo() {
      if (this.frame) this.frame.src = '';
      this.dialogProduct?.replaceChildren();
      this.lastTrigger?.focus();
    }

    async handleSubmit(event) {
      const form = event.target.closest('.pawlycozy-youtube__add-form');
      if (!form) return;
      event.preventDefault();
      const button = form.querySelector('button[type="submit"]');
      const status = form.parentElement.querySelector('[data-add-status]');
      button.disabled = true;
      try {
        const response = await fetch(`${this.dataset.cartAddUrl}.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        });
        if (!response.ok) throw new Error(String(response.status));
        const item = await response.json();
        status.textContent = this.dataset.copyAdded;
        this.dispatchEvent(new CustomEvent('pawlycozy:cart-added', { bubbles: true, detail: { item } }));
      } catch (error) {
        status.textContent = this.dataset.copyError;
        button.disabled = false;
      }
    }
  }

  if (!customElements.get('pawlycozy-youtube')) {
    customElements.define('pawlycozy-youtube', PawlycozyYoutube);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-product-tabs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const tabTitles = document.querySelectorAll('.tab-title');
    const tabContents = document.querySelectorAll('.tab-content');

    if (tabTitles.length && tabContents.length && tabTitles.length === tabContents.length) {
      tabTitles.forEach((title, i) => {
        title.addEventListener('click', function (e) {
          e.preventDefault();
          if (title.classList.contains('is-active')) return;
          tabTitles.forEach(t => t.classList.remove('is-active'));
          tabContents.forEach(c => c.classList.remove('is-active'));
          title.classList.add('is-active');
          setTimeout(() => {
            const content = tabContents[i];
            content.classList.add('is-animating');
            content.classList.add('is-active');
            content.addEventListener('transitionend', function handler() {
              content.classList.remove('is-animating');
              content.removeEventListener('transitionend', handler);
            });
          }, 10);
        });
      });
    }

    const toggleLinks = document.querySelectorAll('.toggle-link');

    toggleLinks.forEach(toggleLink => {
      toggleLink.addEventListener('click', function(e) {
        e.preventDefault();

        const toggleTitle = toggleLink.closest('.toggle-title');
        if (!toggleTitle) return;

        const tabTitleText = document.querySelector('.tab-title-text');
        if (tabTitleText) {
          tabTitleText.textContent = toggleLink.textContent;
        }

        const viewContentType = toggleTitle.dataset.viewContent;
        const content = toggleTitle.nextElementSibling;
        if (!content) return;

        switch (viewContentType) {
          case 'sidebar': {
            const drawerContent = document.querySelector('.drawer-content-wrapper');
            if (drawerContent) {
              drawerContent.innerHTML = '';
              drawerContent.appendChild(content.cloneNode(true));
              renderVideo();
            }
            break;
          }
          case 'popup': {
            const popupContent = document.querySelector('.popup-content-wrapper');
            if (popupContent) {
              popupContent.innerHTML = '';
              popupContent.appendChild(content.cloneNode(true));
              renderVideo();
            }
            break;
          }
          default:
            toggleTitle.classList.toggle('is-open');
        }
      });
    });
    const modalTemplate = `
      <side-drawer
        class="popup__content video-modal drawer fixed top-0 left-0 z-9 w-screen h-full flex justify-center no-js-hidden"
        element-s-popup=""
        id="PopupModal-AZDFEMWdKNDFCVHdoM__popup_link_desc_video"
        data-moved="true"
      >
        <div
          id="Drawer-Overlay-AZDFEMWdKNDFCVHdoM__popup_link_desc_video"
          class="drawer__overlay fixed inset-0 cursor-pointer"
          style="transform: translateX(0px)"
        ></div>
        <div
          class="popup__inner color-scheme-1 popup__inner--video w-auto h-full absolute-c-c flex flex-column global-settings-popup"
        >
          <div
            class="popup__inner--content relative w-full h-full overflow-auto cus-scrollbar"
          >
            <div class="video-modal__content-block">Video</div>
            <button
              onclick="this.closest('side-drawer').close()"
              class="button button-unstyled close-button popup__close minimum-touch-target-before drawer__close block t-button bor-none rounded-full cursor-pointer absolute"
              type="button"
              aria-label="Close dialog"
              style="--top: 0.3rem; --right: 0.3rem"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                class="icon icon-close"
                viewBox="0 0 18 17"
              >
                <path
                  fill="currentColor"
                  d="M.865 15.978a.5.5 0 0 0 .707.707l7.433-7.431 7.579 7.282a.501.501 0 0 0 .846-.37.5.5 0 0 0-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 1 0-.707-.708L8.991 7.853 1.413.573a.5.5 0 1 0-.693.72l7.563 7.268z"
                ></path>
              </svg>
            </button>
          </div>
        </div>
      </side-drawer>
    `;
    document.body.insertAdjacentHTML('beforeend', modalTemplate);

    function renderVideo() {
      const videoOpenPopups = document.querySelectorAll('.video-open-popup');
    
      if (videoOpenPopups.length > 0) {
        videoOpenPopups.forEach(videoOpenPopup => {
          videoOpenPopup.addEventListener('click', function(e) {
            e.preventDefault();

            const videoId = videoOpenPopup.dataset.videoId;
            const videoWrapper = document.querySelector('.video-modal__content-block');

            const youtubeIframe = `
            <iframe width="100%" src="https://www.youtube.com/embed/${videoId}?si=6yJ56P_BJEG5d2Uq" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            `;

            videoWrapper.innerHTML = youtubeIframe;
          });
        });
      }
    }
    renderVideo();
  });

  } catch(e) { console.error(e); }
})();
})();
